// extracted by mini-css-extract-plugin
module.exports = {"title":"title-module--title--3-XY2","icon":"title-module--icon--2cumU"};